var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.313c-5.35 0-9.688 4.337-9.688 9.687S14.65 29.688 20 29.688c5.35 0 9.688-4.338 9.688-9.688 0-5.35-4.338-9.688-9.688-9.688zm5.082 4.605c2.557 2.556 2.735 6.464.808 9.204L15.878 14.11c2.742-1.928 6.65-1.747 9.204.808zM14.918 25.082c-2.557-2.556-2.735-6.464-.808-9.204L24.122 25.89c-2.742 1.928-6.65 1.747-9.204-.808z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ra0v9z0yfa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.313c-5.35 0-9.688 4.337-9.688 9.687S14.65 29.688 20 29.688c5.35 0 9.688-4.338 9.688-9.688 0-5.35-4.338-9.688-9.688-9.688zm5.082 4.605c2.557 2.556 2.735 6.464.808 9.204L15.878 14.11c2.742-1.928 6.65-1.747 9.204.808zM14.918 25.082c-2.557-2.556-2.735-6.464-.808-9.204L24.122 25.89c-2.742 1.928-6.65 1.747-9.204-.808z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ra0v9z0yfa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 10H10v20h20V10z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanSmall);
export default __webpack_public_path__ + "static/media/ban-small.f737f093b77e15ad700d7e130739d963.svg";
export { ForwardRef as ReactComponent };